module.exports = __webpack_public_path__ + "img/1 (3).e9a1808d.png";